// validationConfig.js

export const propertyValidationConfig = {
  Apartments: [
    "areaDetails",
    "selectedBedRooms",
    "bathRooms",
    "carParking",
    "status",
    "flatOnFloor",
    "totalFloors",
    "mainDoorFacing",
    "balconies",
    "furnishing",
    "ratePerSqFt",
    "propertyFlooring",
    "transactionType",
    "stampDuty",
    "approvalAuthority",
  ],

  Villas: [
    "flatSuperArea",
    "bedRooms",
    "bathRooms",
    "carParking",
    "status",
    "flatOnFloor",
    "totalFloors",
    "mainDoorFacing",
    "balconies",
    "furnishing",
    "ratePerSqFt",
    "propertyFlooring",
    "transactionType",
    "stampDuty",
    "approvalAuthority",
  ],

  Plots: [
    "ratePerSqFt",
    "transactionType",
    "approvalAuthority",
  ],
};